import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='eBay'
        title='eBay Prohibited Items You Should Not List'
      >
        <p>
          Whether you are selling full-time or part-time on eBay, the giant e-commerce platform has several policies you
          must follow. This includes reviewing your listings and evaluating your items before posting them.{' '}
        </p>
        <p>
          Before you even dive into how to increase your earnings, get informed on the site's policies. You certainly
          don't want any of your items removed and/or your account to be restricted or, worse, suspended.
        </p>
        <p>
          eBay has a couple of forbidden items and restricted ones. Note that different websites have their
          restrictions, but here is a short guide for eBay US and UK. This is not an exhaustive list but a general
          guideline.
        </p>
        <h3>Prohibited items</h3>
        <h4>1) Used clothing, cosmetics, and perfume</h4>
        <p>
          Only new garments are allowed–be it from a department store, a sale from a certain brand, or a surplus.
          Anything secondhand, even worn once, should not be on your list. Similar goes with perfume such as testers,
          decanters, dramming bottles, and cosmetics like lipsticks, blush, eyeshadow palette, and the like.
        </p>
        <p>
          Be careful with intimates like underwear and nightgowns. Make sure these are all brand new as well before you
          sell them. All this is to maintain proper hygiene and avoid health issues–keeping buyers safe.
        </p>
        <p>
          Government and transit companies' uniforms are also forbidden to be sold. It includes all employees, no matter
          the position.{' '}
        </p>
        <h4>2) Alcohol and Drug paraphernalia</h4>
        <p>
          This category covers all types of liquor except a rare wine collection which can only be sold by approved or
          official eBay sellers.
        </p>
        <p>
          As for drugs, marijuana, tobacco pipes, vapes, and other smoking accessories are also not allowed. All types
          of drug paraphernalia violate federal, state, and international law.
        </p>
        <h4>3) COVID-19 supplies and essentials</h4>
        <p>
          N95/N100 masks, including surgical ones, disinfecting wipes, hand sanitizers, gels, and test kits, have a ban.
          Any other listings with the keywords "COVID-19," "coronavirus," and "2019nCOV" are also being removed since
          early 2020. That is why sellers should be mindful of selling other medical or hygiene products and essentials.
        </p>
        <h4>4) Electronics equipment</h4>
        <p>
          While usual gadgets such as phone cables, chargers, speakers, etc., are allowed, items for surveillance
          aren't. Such communication devices are prohibited and anything that Federal Communications Commission (FCC)
          restricted.
        </p>
        <h4>5) Animals and wildlife products</h4>
        <p>
          Most animal species, even small ones like hamsters and fish, are not considered. The only acceptable products
          you can offer are animal food (crickets, worms, roaches). However, those that are made from bones and skins
          are strictly limited.
        </p>
        <h4>6) Contracts and fundraising listings</h4>
        <p>
          Any goods subject to a third party's contract should be discussed first with the involved parties or a lawyer
          before selling anywhere.
        </p>
        <p>
          For listings for charities or fundraising, these should be supported by non-profitability documents and comply
          with eBay's policy and requirements.
        </p>
        <h4>7) Gift cards and vouchers</h4>
        <p>
          These are allowed only if the value doesn't exceed $500 as long as you have it in stock (and can prove it to
          the potential buyer). However, each card or voucher shouldn't be for sale for more than one (1) unit.
        </p>
        <h4>8) Firearms, weapons, and explosive, flammable, and hazardous materials</h4>
        <p>
          Only certain firearm accessories or parts are allowed, but they have restrictions. This is includes being
          shipped domestically, and both buyer and seller reside in the United States. Radioactive materials, poison or
          toxic chemicals, and explosive precursors are strictly prohibited. However, for Pesticides, sellers must
          follow{' '}
          <a href='https://www.ebay.com/help/policies/prohibited-restricted-items/pesticides-policy?id=4630'>
            other limitations
          </a>
          .
        </p>
        <h4>9) Medical devices without a prescription</h4>
        <p>
          Some professional equipment is allowed, but only when these comply with law requirements. This applies
          especially to those that require licenses for use and/or a prescription.
        </p>
        <h4>10) Art, artifacts, and cave formations</h4>
        <p>
          Reproduction or replicas of artwork can be sold if they don't violate any law, trademarks, or copyrights. The
          legal sale of art is also allowed. However, archeological items such as fossils, formations, gravestones, and
          such are strictly prohibited.
        </p>
        <h3>What is eBay Authenticity Guarantee?</h3>
        <p>
          For buyers, purchasing a branded item only for it to turn out fake is one of the worst experiences. This
          negatively reflects on the seller's credibility, and the buyer can report them to authorities. No seller would
          want this inconvenience of going through investigations and paying the fines accordingly.{' '}
        </p>
        <p>
          This is why eBay launched a multi-step process that verifies items sold on the e-commerce website. Each item
          can carry an "authenticity badge," assuring potential buyers that the product or item is legitimate, in great
          conditions, and came from the brand or label that it was categorized under.
        </p>
        <p>
          The authentication process covers high-value items such as luxury watches (Omega, Cartier, Hublot, Rolex) and
          vintage ones (sold for $2,000 and above in an auction), designer bags (sold for $500 and above), and branded
          sneakers (Jordan and Yeezy).
        </p>
        <h4>How it works</h4>
        <p>
          When a buyer purchases an item eligible for authentication, it is shipped to eBay's facility for verification.
          This service is free of charge, including the shipping to the one who bought it. Once the items or things are
          with the platform's authentication partner, they go through several inspecting processes of inspection.
        </p>
        <p>
          It takes two (2) business days where independent authenticators check the tags, logos, laces, stitching,
          timepiece parts, and even open the box or packaging to ensure they are not counterfeit or look-alikes of the
          real ones.
        </p>
        <p>
          When the item passes, they tag it with a card to prove legitimate. The package is then shipped to the buyer
          with a two (2)-day secure shipping.
        </p>
        <p>
          If the item doesn't pass the authentication process, it is shipped back to the seller. The latter then give a
          full refund to their buyer.
        </p>
        <h3>Violating the policies</h3>
        <p>
          Every member of the e-commerce giant's community must comply with eBay rules and regulations, be it a seller
          or buyer. For sellers, the general rules cover correctly listing items, refraining from providing false
          information about the products, not relisting taken down items, and avoiding posting prohibited items.
        </p>
        Any activity that goes against the policies has corresponding actions and fines. This includes canceling or
        demoting the seller's listings, restricting your account activity, lowering the rating as a seller, and worse,
        account suspension.
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
